import React from "react";
import { Button } from "react-bootstrap";
import "./payment-plans-details.css";
import PaymentMethod from "../../home/components/payment-method";
import ContactProviderModal from "home/components/contact-provider-modal";

function PaymentPlansLayout(props) {
  const defaultViewState = {
    showActions: true,
    panelClass: "col-md-7",
    paymentClass: "col-md-6"
  };

  const viewState = Object.assign({}, defaultViewState, props.viewState);

  let cards = [];
  let banks = [];

  if (props.paymentMethods && props.paymentMethods !== null) {
    cards = props.paymentMethods.filter(
      paymentMethod => paymentMethod["object"] === "card"
    );

    banks = props.paymentMethods.filter(
      paymentMethod => paymentMethod["object"] === "bank_account"
    );
  }

  let linkPaymentMethodButton = (
    <Button
      bsStyle="warning"
      onClick={() =>
        props.handleShow("LinkPaymentMethod", true, {
          currentPlan: props.currentPlan,
          addPaymentMethod: props.addPaymentMethod
        })
      }
    >
      Link new payment method
    </Button>
  );

  const actionButtons = (
    <div className="buttons">
      <div>
        {linkPaymentMethodButton}
        <Button
          bsStyle="warning"
          onClick={() =>
            props.handleShow("AccountHistory", true, {
              currentPlan: props.currentPlan
            })
          }
        >
          View Account History
        </Button>
        <Button
          bsStyle="warning"
          onClick={props.toggleContactsProvider}
        >
          Contact provider
        </Button>
      </div>
    </div>
  );

  const {contactProvider, toggleContactsProvider} = props;
  return (
    <div
      className={"payment-plans-details " + (!props.showDetails ? "hide" : "")}
    >
      <div className="row payment-methods col-sm-12">
        <h4> My Payment Methods</h4>
        <div className="row payment-methods-list col-md-12">
          <div
            className={
              "col-sm-12 " + viewState.panelClass
                ? viewState.panelClass
                : "col-md-8"
            }
          >
            {!!cards.length ? (
              <div className="cards">
                <div className="row cards-header">
                  <div className={viewState.paymentClass}>
                    Your credit and debit cards
                  </div>
                  <div className="col-md-3">Expires</div>
                </div>

                {cards.map(card => (
                  <PaymentMethod
                    key={card.id}
                    paymentMethod={card}
                    removePaymentMethod={() =>
                      props.removePaymentMethod(card.id)
                    }
                    handleShow={props.handleShow}
                    setPaymentMethod={props.setPaymentMethod}
                    viewState={props.viewState}
                    selectedPaymentMethod={props.selectedPaymentMethod}
                    emptyStepOption={props.emptyStepOption}
                    currentPlan={props.currentPlan.paymentId}
                  />
                ))}
              </div>
            ) : null}

            <br />

            {!!banks.length ? (
              <div className="banks">
                <div className="row cards-header">
                  <div className={viewState.paymentClass}>Your checking accounts</div>
                  <div className="col-md-3">ACH</div>
                </div>

                {banks.map(check => (
                  <PaymentMethod
                    key={check.id}
                    paymentMethod={check}
                    handleShow={props.handleShow}
                    viewState={props.viewState}
                    removePaymentMethod={() =>
                      props.removePaymentMethod(check.id)
                    }
                    setPaymentMethod={props.setPaymentMethod}
                    selectedPaymentMethod={props.selectedPaymentMethod}
                    emptyStepOption={props.emptyStepOption}
                    currentPlan={props.currentPlan.paymentId}
                    component={props.component}
                  />
                ))}
              </div>
            ) : null}
          </div>

          <div className="col-sm-12 col-md-4">
            {viewState.showActions ? actionButtons : null}
          </div>
        </div>
      </div>
      {viewState.showLinkPaymentMethodButton ? linkPaymentMethodButton : null}
      {contactProvider &&
        <ContactProviderModal
          show
          handleShow={toggleContactsProvider}
          provider={contactProvider}
        />
      }
    </div>
  );
}

export default PaymentPlansLayout;



// WEBPACK FOOTER //
// ./src/home/components/payment-plans-layout.js